import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import type { FC } from 'react';
import { Box, Button, Container } from '@/DesignSystem/Component';
import { FILE_BROWSER_URL, LINKS } from '@/Module/Core/Constant';
import { preparePageTitle } from '@/Module/Core/Helper';
import { useAppSelector } from '@/Module/Store/Hook';
import { MciGift } from '@/Module/Subscription/Component';
import { useGuestVariant } from '@/Module/Subscription/Hooks';
const PaymentStatus: FC = () => {
  const variant = useGuestVariant();
  const code = useAppSelector(state => state.subscription.mciCouponInfo);
  const isPaymentSuccessful = useAppSelector(state => state.subscription.guestPaymentSuccess);
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="PaymentStatus.tsx">
        <title>{preparePageTitle(`${isPaymentSuccessful ? 'پرداخت موفق' : 'پرداخت ناموفق'}`)}</title>
      </Head>
      <Container className="my-8 max-w-[480px] md:my-20" data-sentry-element="Container" data-sentry-source-file="PaymentStatus.tsx">
        <Box color="secondary" className="border-4 border-blueFive bg-grade-description bg-contain bg-right-bottom bg-no-repeat p-4 md:py-10" data-sentry-element="Box" data-sentry-source-file="PaymentStatus.tsx">
          <div className="mb-12 flex items-center justify-center">
            <Image src={`${FILE_BROWSER_URL}/img/${isPaymentSuccessful ? 'img-success.svg' : 'img-failed.svg'}`} alt={isPaymentSuccessful ? 'پرداخت موفق' : 'پرداخت ناموفق'} width={281} height={258} data-sentry-element="Image" data-sentry-source-file="PaymentStatus.tsx" />
          </div>

          <p className="mb-8 text-center text-2xl font-bold leading-[2.5rem] text-blueFive">
            {isPaymentSuccessful ? `پرداخت با موفقیت از طریق کیف پول ${variant} انجام شد.` : `پرداخت از کیف پول  ${variant}، ناموفق بود، لطفاً دوباره امتحان کن.`}
          </p>

          {code.length > 0 && <MciGift code={code} />}

          <Button href={LINKS.LEARNING} as={Link} variant="shadow" color="primary" className="w-full" radius="circle" size="large" bold data-sentry-element="Button" data-sentry-source-file="PaymentStatus.tsx">
            برگشتن به صفحه اصلی
          </Button>
        </Box>
      </Container>
    </>;
};
export default PaymentStatus;